<script lang="ts">

  import { Button } from "$lib/components/ui/button"
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import { Separator } from "$lib/components/ui/separator"
  import { appStore } from "$lib/stores/app-store.svelte"

  let { open, setOpen }: {
    open: boolean
    setOpen: (open: boolean) => void
  } = $props()

  const user = $derived(appStore.user)

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}
>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}
  >
    <DialogHeader>
      <DialogTitle>Profil</DialogTitle>
      <DialogDescription>Informasi user yang sedang digunakan</DialogDescription>
    </DialogHeader>
    <div class="space-y-3">
      <div>
        <Label>Nama</Label>
        <div class="text-desc">{user?.name ?? "-"}</div>
      </div>
      <div>
        <Label>Username</Label>
        <div class="text-desc">{user?.username ?? "-"}</div>
      </div>
      <div>
        <Label>Email</Label>
        <div class="text-desc">{user?.email || "-"}</div>
      </div>
      <div>
        <Label>Telepon</Label>
        <div class="text-desc font-mono">{user?.phone || "-"}</div>
      </div>
      <Separator/>
      <div>
        <Label>NIP</Label>
        <div class="text-desc font-mono">{user?.employee?.number || "-"}</div>
      </div>
      <div>
        <Label>Posisi</Label>
        <div class="text-desc">{user?.employee?.position || "-"}</div>
      </div>
    </div>
    <DialogFooter>
      <Button
        variant="outline"
        onclick={() => setOpen(false)}
      >
        Tutup
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>
